import React, { useEffect, useState, useRef } from 'react';
import {Col, Row, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { listProducts } from '../actions/productActions';
import Loader from '../components/Loader';
import Message from '../components/Message';
import ProfileCard from '../components/Profile/ProfileCard';
import WelcomeMessage from '../components/Profile/WelcomeMessage';
import { detail } from '../actions/userActions';
import { logout } from '../actions/userActions';

function ProfileScreen() {
  const mainContentRef = useRef(null);
  const {
    userReducers: { user, userDetailsLoading, userDetailsError },
    addressReducers: { addresses },
    cardReducers: { cards }
  } = useSelector((state) => state)

  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const [updateModalShow, setUpdateModalShow] = useState(false)

  useEffect(() => {
    dispatch(detail())
  }, [dispatch])

  // Handle authentication error
  useEffect(() => {
    if (userDetailsError && userDetailsError.includes('Authentication credentials were not provided')) {
      // Log out the user and redirect to home page
      dispatch(logout())
      navigate('/')
    }
  }, [userDetailsError, dispatch, navigate])

  // Handle focus management when route changes
  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.pathname]);

  return (
    <>
      {userDetailsLoading && <Loader />}
      {userDetailsError && !userDetailsError.includes('Authentication credentials were not provided') && <Message variant='danger'>{userDetailsError}</Message>} 
      
      <Container fluid>
        <Row>
          <Col md={3}>
            <ProfileCard user={user} updateModalShow={() => setUpdateModalShow(true)} />
          </Col>

          <Col md={9} className="mt-3 mt-md-0" ref={mainContentRef}>
            {location.pathname === '/profile' && user && <WelcomeMessage user={user} />}
            <Outlet />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default ProfileScreen
